module.exports = __webpack_public_path__ + "static/media/peitu.2e0301a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peitu.png
// module id = 462
// module chunks = 2